import React from 'react'
import styled from 'styled-components'

import DeviceMetricForm from 'pages/shared/DeviceMetricForm'

import { PageHeader, PageTitle, SinglePanePage, screenSize } from 'styles/shared'
import { color } from 'styles/colors'

const deviceMetric = {
  id: '',
  name: '',
  color: color('thirdHeaderText'),
  description: '',
  callToAction: [],
  draft: true,
  unit: '',
  sort: 0,
  charts: [],
  hasMetricStatuses: false,
  hasMetricValues: false,
  validatedSaveType: ''
}

const AddDeviceMetric = () => (
  <>
    <PageHeader>
      <S.PageTitle>New Device Metric</S.PageTitle>
    </PageHeader>
    <S.SinglePanePage>
      <DeviceMetricForm
        validatedSaveType="create"
        deviceMetric={deviceMetric}
      />
    </S.SinglePanePage>
  </>
)

export default AddDeviceMetric

const S = {
  SinglePanePage: styled(SinglePanePage)`
    @media ${screenSize.small} {
      margin-top: 0;
    }
  `,
  PageTitle: styled(PageTitle)`
    @media ${screenSize.small} {
      display: block;
    }
  `
}
